import { render, staticRenderFns } from "./TabletPaperIcon.vue?vue&type=template&id=4391790c&"
import script from "./TabletPaperIcon.vue?vue&type=script&lang=js&"
export * from "./TabletPaperIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports